import React from 'react'
import { Helmet } from 'react-helmet'

import MainLayout from 'src/components/MainLayout'
import styled from 'styled-components'
import Prologue from './Prologue'
import Ready from './Ready'
import WordHard from './WordHard'
import background from 'src/assets/images/NewScene/background_web_red.svg'

export const paramTeam = '/team'

const Wrapper = styled.section`
background: url(${background}) no-repeat center;
`

const TeamPage: React.FC = () => {
  return (
    <MainLayout>
       <Helmet>
        <title>
          Senspark | Team
        </title>
        <meta
          property='og:title'
          content='Senspark | Team'
        />
      </Helmet>
      <Wrapper>
        {/* <Prologue /> */}
        <WordHard />
        <Ready />
      </Wrapper>
    </MainLayout>
  )
}

export default TeamPage
